import dayjs from 'dayjs'

export default {
  name: 'TransferHistoryTable',
  props: {
    rows: { type: Array, required: true },
    logStatus: { type: Object, required: false, default: () => ({}) },
    logEinvoiceStatus: { type: Object, required: false, default: () => ({}) },
  },
  emits: ['toggle-row'],
  methods: {
    formatDate(v) {
      const d = dayjs(v)
      return d.isValid() ? d.format('DD/MM/YYYY HH:mm') : v
    },
    toggleRow(r) {
      this.$emit('toggle-row', r)
    },
    preview(v) {
      const raw = this.formatJson(v)

      const oneLine = raw.replace(/\s+/g, ' ').trim()

      if (!oneLine) return '...'

      return oneLine.length > 180
        ? oneLine.slice(0, 180) + '…'
        : oneLine
    },
    formatJson(v) {
      if (v == null) return ''

      try {
        // nếu là string JSON thì parse trước
        const parsed = typeof v === 'string' ? JSON.parse(v) : v
        return JSON.stringify(parsed, null, 2)
      } catch {
        return typeof v === 'string' ? v : String(v)
      }
    }
  },
}
